import api from "./api";

async function getRoleById(id) {
  try {
    var response = await api.get(`api/roles/${id}`);
    return response.data;
  } catch (error) {
    return false;
  }
}

async function createRole({
  name,
  isAdmin,
  canUpdateSettings,
  paymentRequestLevel,
  paymentLevel,
  customerLevel,
  reconciliationLevel,
  ledgerPaymentLevel,
  payoutLevel,
  messageTemplateLevel,
  paymentRequestTemplateLevel,
  useAiFeatures,
}) {
  try {
    var response = await api.post("api/roles", {
      name,
      isAdmin,
      canUpdateSettings,
      paymentRequestLevel,
      paymentLevel,
      customerLevel,
      reconciliationLevel,
      ledgerPaymentLevel,
      payoutLevel,
      messageTemplateLevel,
      paymentRequestTemplateLevel,
      useAiFeatures,
    });
    return response.data;
  } catch (error) {
    return false;
  }
}

async function updateRole({
  id,
  name,
  isAdmin,
  canUpdateSettings,
  paymentRequestLevel,
  paymentLevel,
  customerLevel,
  reconciliationLevel,
  ledgerPaymentLevel,
  payoutLevel,
  messageTemplateLevel,
  paymentRequestTemplateLevel,
  useAiFeatures,
}) {
  try {
    var response = await api.put(`api/roles/${id}`, {
      name,
      isAdmin,
      canUpdateSettings,
      paymentRequestLevel,
      paymentLevel,
      customerLevel,
      reconciliationLevel,
      ledgerPaymentLevel,
      payoutLevel,
      messageTemplateLevel,
      paymentRequestTemplateLevel,
      useAiFeatures,
    });
    return response.data;
  } catch (error) {
    return false;
  }
}

async function getRoles() {
  try {
    var response = await api.get("api/roles");
    return response.data;
  } catch (error) {
    return false;
  }
}

export { getRoleById, createRole, updateRole, getRoles };
